import { RootState } from '../../store';
import { createSelector } from 'reselect';

const selectGraphDataLastValueState = (state: RootState) => state.graphDataLastValue;

export const selectGraphDataLastValues = createSelector(
    selectGraphDataLastValueState,
    (graphDataLastValue) => graphDataLastValue.items,
);

const getSensorId = (state: RootState, sensorId: number) => sensorId;

export const selectGraphDataLastValueItemById = createSelector(
    selectGraphDataLastValues,
    getSensorId,
    (items, id) => items.find(value => value.id === id) || null,
);

export const selectGraphDataLastValuesErrors = createSelector(
    selectGraphDataLastValueState,
    (graphDataLastValue) => graphDataLastValue.errors,
);

export const selectGraphDataLastValuesById = createSelector(
    selectGraphDataLastValueItemById,
    sensor => sensor?.latestValue ?? null,
);
